"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutageChartWrapper = exports.MainChartWrapper = exports.MainChartRight = exports.MainChartLeft = exports.FillAvailableSpace = exports.ChartContainer = exports.BatteryPercentageChartWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MainChartWrapper = _styled["default"].section(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));

exports.MainChartWrapper = MainChartWrapper;

var MainChartLeft = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n"])));

exports.MainChartLeft = MainChartLeft;
var downloadButtonWidth = '30px';

var MainChartRight = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 ", ";\n  justify-content: flex-end;\n  padding-bottom: 10px;\n"])), downloadButtonWidth);

exports.MainChartRight = MainChartRight;

var BatteryPercentageChartWrapper = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  position: relative;\n"])), downloadButtonWidth);

exports.BatteryPercentageChartWrapper = BatteryPercentageChartWrapper;

var OutageChartWrapper = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), downloadButtonWidth);

exports.OutageChartWrapper = OutageChartWrapper;

var FillAvailableSpace = _styled["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n"])));

exports.FillAvailableSpace = FillAvailableSpace;

var ChartContainer = _styled["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

exports.ChartContainer = ChartContainer;